<template>
    <drop v-if="!inWindow" class="listDrop" :class="{listDropDragOver: dragging}" @dragover="handleDragOver"  @dragend="dragging=false" @dragleave="dragging=false" @drop="doDrop">
        <div v-if="dragging" class="has-text-white pointerEventsOff">
            &nbsp;&nbsp;<i class="fa fa-arrow-right"></i>&nbsp;
            <i class="fas fa-band-aid"></i>
        </div>
    </drop>
</template>

<script>
import { Drag, Drop } from 'vue-drag-drop'
export default {
    name: 'bundle',
    components: {Drop},
    props: {
        //info: Object,
        //listIndex: Number,
        inWindow: {
            type: Boolean,
            default: false
        }
    },

    data: function(){
        return {
            dragging: false,
            rootName: '',
            az: az,
            bc: [],
            branch: [],
            listIndex: 0
        }
    },

    methods: {
        handleDragOver: function(data, event){
            if(data.type == 'list'){
                this.dragging = true;
            }
        },
        doDrop: async function(data, event){

          if(data.collabId && data.fromSub){
                    if(await this.$root.app.checkDescendantsForForeign(data.draggedId)){
                        this.dragging = false
                        this.$root.app.showModalOK({message: 'This bundle has content contributed by other collab members. Please remove this content before moving the bundle out of the collab.'})
                        
                        return
                    }
                    /* this.$root.app.showModalOK({message: 'Removing bundles from collab bundle coming soon. Stay tuned'})
                    return */ 
                }
    
            let movedBundle = this.$root.app.bundles.findIndex((e) => {
                return e.id == data.draggedId
            })

            this.listIndex = this.$root.app.treeNoInbox.length

            var copyOfBundle,
            copyOfBundle = this.$root.app.bundles[movedBundle] //JSON.parse(JSON.stringify(this.$root.app.bundles[movedBundle]))

            let openWindowId
            if(this.$parent.windowOpen){
                openWindowId = this.$root.app.bundles[this.$parent.currOpenWindow].id
                
            }

            //Move the bundle
            if(data.fromSub){
                this.$root.app.bundleMover(data.bundleId, 'root', this.listIndex, copyOfBundle, this.$root.app, [data.bundleId], null, null, null, null, null)
                        /* parentId, targetId, targetIndex, bundle, app, branch, listIndex) */                         
            } else {
                let rootId = copyOfBundle.branch[0]
                copyOfBundle = this.$root.app.bundles.find(e => {
                    return e.id == rootId;
                }) 
                //console.log(copyOfBundle)
                let draggedListIndex = this.$root.app.treeNoInbox.findIndex(e => {
                    return e.id == rootId;
                })
                this.$root.app.bundleMover('root','root', this.listIndex, copyOfBundle, this.$root.app, null, draggedListIndex, null, null, null, null)
            }

            //TODO fix this --reset open window 
            if(this.$parent.windowOpen){
                let lInd = this.$root.app.treeNoInbox.findIndex(e => {
                    return e.id == openWindowId
                })

                //console.log('ind-' + lInd)
                this.$parent.openWindow(openWindowId, lInd)
            }

        
            this.dragging = false;
        },
       /*  dragStart: function(data, e){
            var img = document.getElementById('bundleDragger')
            e.dataTransfer.setDragImage(img, 0, 30);
        }, */
    }
}
</script>
